export default __webpack_public_path__ + "static/media/t_wdt_c_3.8639c30d.mp3";